import { NgModule } from '@angular/core';

import { LazyLoadConfig } from './lazy-load-config';
import { LazyLoadImageDirective } from './lazy-load-images.directive';
import { LazyLoadObserverService } from './lazy-load-observer.service';
import { LazyTemplateDirective } from './lazy-template.directive';

@NgModule({
    exports: [
        LazyLoadImageDirective,
        LazyTemplateDirective,
    ],
    declarations: [
        LazyLoadImageDirective,
        LazyTemplateDirective,
    ],
    providers: [
        LazyLoadConfig,
        LazyLoadObserverService,
    ],
})
export class LazyLoadModule { }
